import { useTranslation } from "react-i18next"

import type { HostedAgentLifecycleAction, HostedAgentLifecycleStatus } from "@/api/admin-api"

import { Badge } from "@/components/ui/badge"
import { Spinner } from "@/components/ui/spinner"

import {
  HOSTED_AGENT_LIFECYCLE_ACTION_DEFAULTS,
  HOSTED_AGENT_LIFECYCLE_STATUS_DEFAULTS,
  hostedAgentLifecycleStatusVariant,
} from "../utils/hosted-agent-lifecycle"

/**
 * Status chip for a lifecycle request: "Upgrade · running" etc. Shared by the
 * table row, the map node and the lifecycle panel so every surface reads the
 * same words for the same state.
 */
export function HostedAgentLifecycleStatusBadge({
  action,
  status,
  showAction = true,
}: {
  action: HostedAgentLifecycleAction
  status: HostedAgentLifecycleStatus
  showAction?: boolean
}) {
  const { t } = useTranslation()
  const statusLabel = t(`adminDashboard.hostedAgents.lifecycle.status.${status}`, {
    defaultValue: HOSTED_AGENT_LIFECYCLE_STATUS_DEFAULTS[status],
  })
  const actionLabel = t(`adminDashboard.hostedAgents.lifecycle.actions.${action}`, {
    defaultValue: HOSTED_AGENT_LIFECYCLE_ACTION_DEFAULTS[action],
  })
  const isBusy = status === "claimed" || status === "running"
  return (
    <Badge className="gap-1" variant={hostedAgentLifecycleStatusVariant(status)}>
      {isBusy ? <Spinner className="size-3" /> : null}
      {showAction ? `${actionLabel} · ${statusLabel}` : statusLabel}
    </Badge>
  )
}
